// @flow
import { combineReducers } from "redux";
import * as actionTypes from "../constants/actionTypes";
import typologies from "./typologies";
import markets from "./markets";
import searchString from "./searchString";
import type { TypologiesState } from "./typologies";
import type { MarketsState } from "./markets";
import type { SearchStringState } from "./searchString";
import type { Action } from "../actions/filters";

export type MainFilters = {
  +typologies: TypologiesState,
  +markets: MarketsState,
  +searchString: SearchStringState,
  +isLoading: boolean,
  +hasError: boolean,
  +errorMessage: ?string
};

const isLoading = (state = false, action: Action) => {
  switch (action.type) {
    case actionTypes.GET_MAIN_FILTERS:
      return true;

    case actionTypes.GET_MAIN_FILTERS_SUCCESS:
    case actionTypes.GET_MAIN_FILTERS_ERROR:
      return false;

    default:
      return state;
  }
};

const hasError = (state = false, action: Action) => {
  switch (action.type) {
    case actionTypes.GET_MAIN_FILTERS:
    case actionTypes.GET_MAIN_FILTERS_SUCCESS:
      return false;

    case actionTypes.GET_MAIN_FILTERS_ERROR:
      return true;
    default:
      return state;
  }
};

const errorMessage = (state: ?string = null, action: Action) => {
  switch (action.type) {
    case actionTypes.GET_MAIN_FILTERS:
    case actionTypes.GET_MAIN_FILTERS_SUCCESS:
      return null;

    case actionTypes.GET_MAIN_FILTERS_ERROR:
      const { error } = action.payload;
      return error;
    default:
      return state;
  }
};

const mainFilters = combineReducers({
  typologies,
  markets,
  searchString,
  isLoading,
  hasError,
  errorMessage
});

export default mainFilters;



// WEBPACK FOOTER //
// ./src/reducers/mainFilters.js